import { doc, setDoc, getDoc, collection, query, where, getDocs, orderBy } from 'firebase/firestore';
import { db } from '../config/firebase';

/**
 * Save or update user profile
 */
export const saveUserProfile = async (userId, profileData) => {
  try {
    const userRef = doc(db, 'users', userId);
    await setDoc(userRef, {
      ...profileData,
      updatedAt: new Date(),
    }, { merge: true }); // merge: true updates existing or creates new
    
    return true;
  } catch (error) {
    console.error('Error saving user profile:', error);
    throw new Error('Failed to save user profile');
  }
};

/**
 * Get user profile
 */
export const getUserProfile = async (userId) => {
  try {
    const userRef = doc(db, 'users', userId);
    const userSnap = await getDoc(userRef);
    
    if (userSnap.exists()) {
      return userSnap.data();
    }
    return null;
  } catch (error) {
    console.error('Error getting user profile:', error);
    throw new Error('Failed to get user profile');
  }
};

/**
 * Get all leads for a user
 */
export const getUserLeads = async (userId) => {
  try {
    const leadsRef = collection(db, 'users', userId, 'leads');
    const q = query(leadsRef, orderBy('createdAt', 'desc'));
    const querySnapshot = await getDocs(q);
    
    const leads = [];
    querySnapshot.forEach((doc) => {
      leads.push({
        id: doc.id,
        ...doc.data(),
      });
    });
    
    return leads;
  } catch (error) {
    console.error('Error getting user leads:', error);
    throw new Error('Failed to get user leads');
  }
};

/**
 * Get user's custom events
 */
export const getUserCustomEvents = async (userId) => {
  try {
    const userRef = doc(db, 'users', userId);
    const userSnap = await getDoc(userRef);
    
    if (userSnap.exists()) {
      const data = userSnap.data();
      return data.customEvents || [];
    }
    return [];
  } catch (error) {
    console.error('Error getting user custom events:', error);
    throw new Error('Failed to get user custom events');
  }
};

/**
 * Add a custom event to user's list
 */
export const addUserCustomEvent = async (userId, eventName) => {
  try {
    const userRef = doc(db, 'users', userId);
    const userSnap = await getDoc(userRef);
    
    let customEvents = [];
    if (userSnap.exists()) {
      customEvents = userSnap.data().customEvents || [];
    }
    
    // Add event if it doesn't already exist
    if (!customEvents.includes(eventName)) {
      customEvents.push(eventName);
      await setDoc(userRef, {
        customEvents: customEvents,
        updatedAt: new Date(),
      }, { merge: true });
    }
    
    return customEvents;
  } catch (error) {
    console.error('Error adding custom event:', error);
    throw new Error('Failed to add custom event');
  }
};

